var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1251 51.0938L46.823 44.7917C46.6667 44.6876 46.5105 44.5834 46.3542 44.5834H45.6772C47.2917 42.7084 48.3334 40.2084 48.3334 37.5001C48.3334 31.5626 43.4376 26.6667 37.5001 26.6667C31.5105 26.6667 26.6667 31.5626 26.6667 37.5001C26.6667 43.4897 31.5105 48.3334 37.5001 48.3334C40.2084 48.3334 42.6563 47.3438 44.5834 45.7292V46.4063C44.5834 46.5626 44.6355 46.7188 44.7397 46.8751L51.0417 53.1772C51.3022 53.4376 51.7188 53.4376 51.9272 53.1772L53.1251 51.9792C53.3855 51.7709 53.3855 51.3542 53.1251 51.0938ZM37.5001 45.8334C32.8647 45.8334 29.1667 42.1355 29.1667 37.5001C29.1667 32.9167 32.8647 29.1667 37.5001 29.1667C42.0834 29.1667 45.8334 32.9167 45.8334 37.5001C45.8334 42.1355 42.0834 45.8334 37.5001 45.8334Z",
    fill: "#808285"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.f4707e8f0f072952072d757f6b56e8ad.svg";
export { ForwardRef as ReactComponent };